import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'th',
  months: [
    'มกราคม',
    'กุมภาพันธ์',
    'มีนาคม',
    'เมษายน',
    'พฤษภาคม',
    'มิถุนายน',
    'กรกฎาคม',
    'สิงหาคม',
    'กันยายน',
    'ตุลาคม',
    'พฤศจิกายน',
    'ธันวาคม',
  ],
  monthsShort: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
  weekdays: ['วันอาทิตย์', 'วันจันทร์', 'วันอังคาร', 'วันพุธ', 'วันพฤหัสบดี', 'วันศุกร์', 'วันเสาร์'],
  weekdaysMin: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
  weekdaysShort: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
  formats: {
    LT: 'HH:mm น.',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm น.',
    'LLL-Y': 'D MMMM HH:mm น.',
    LLLL: 'ddddที่ D MMMM YYYY HH:mm น.',
    'LLLL-Y': 'dddd D MMMM HH:mm น.',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd D MMM YYYY h:mm A',
    'llll-Y': 'ddd D MMM h:mm A',
    'll-Y+w': 'ddd D MMM',
    'LT+to': 'HH:mm น. ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY HH:mm น. ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { other: '%s ปีที่แล้ว' },
    M: { other: '%s เดือนที่แล้ว' },
    w: { other: '%s น. ที่แล้ว' },
    d: { other: '%s วันที่แล้ว' },
    h: { other: '%s ชม. ที่แล้ว' },
    m: { other: '%s นาทีที่แล้ว' },
    s: { other: '%s วินาทีที่แล้ว' },
  },
  future: {
    y: { other: 'ใน %s ปี' },
    M: { other: 'ใน %s เดือน' },
    w: { other: 'ใน %s สัปดาห์' },
    d: { other: 'ใน %s วัน' },
    h: { other: 'ใน %s ชม.' },
    m: { other: 'ใน %s นาที' },
    s: { other: 'ใน %s วินาที' },
  },
  pastLong: {
    y: { other: '%s ปีที่แล้ว' },
    M: { other: '%s เดือนที่ผ่านมา' },
    w: { other: '%s สัปดาห์ที่ผ่านมา' },
    d: { other: '%s วันที่ผ่านมา' },
    h: { other: '%s ชั่วโมงที่ผ่านมา' },
    m: { other: '%s นาทีที่ผ่านมา' },
    s: { other: '%s วินาทีที่ผ่านมา' },
  },
  futureLong: {
    y: { other: 'ในอีก %s ปี' },
    M: { other: 'ในอีก %s เดือน' },
    w: { other: 'ในอีก %s สัปดาห์' },
    d: { other: 'ในอีก %s วัน' },
    h: { other: 'ในอีก %s ชั่วโมง' },
    m: { other: 'ในอีก %s นาที' },
    s: { other: 'ในอีก %s วินาที' },
  },
  abbr: {
    y: { other: '%s ปี' },
    M: { other: '%s เดือน' },
    w: { other: '%s สัปดาห์' },
    d: { other: '%s วัน' },
    h: { other: '%s ชม.' },
    m: { other: '%s นาที' },
    s: { other: '%s วินาที' },
  },
  full: {
    y: { other: '%s ปี' },
    M: { other: '%s เดือน' },
    w: { other: '%s สัปดาห์' },
    d: { other: '%s วัน' },
    h: { other: '%s ชั่วโมง' },
    m: { other: '%s นาที' },
    s: { other: '%s วินาที' },
  },
  justNow: 'เมื่อสักครู่',
  yesterday: 'เมื่อวานนี้',
  today: 'วันนี้',
  tomorrow: 'พรุ่งนี้',
  weekStart: 0,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'h:mm A': 'HH:mm น.' },
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'MMMM D', end: 'D' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D MMM', end: 'D MMM' },
    Y: { start: 'ddd D MMM YYYY', end: 'ddd D MMM YYYY' },
    'Y-1': { start: 'ddd D MMM', end: 'ddd D MMM YYYY' },
    M: { start: 'ddd D MMM', end: 'ddd D MMM' },
    D: { start: 'ddd D MMM', end: 'ddd D MMM' },
    yt: { start: 'D MMM YYYY HH:mm น.', end: 'D MMM YYYY HH:mm น.' },
    mt: { start: 'D MMM HH:mm น.', end: 'D MMM HH:mm น.' },
    dt: { start: 'D MMM HH:mm น.', end: 'D MMM HH:mm น.' },
    t: { start: 'HH:mm น.', end: 'HH:mm น.' },
    'yt+to': { start: 'D MMM YYYY HH:mm น.', end: 'D MMM YYYY HH:mm น. ([GMT]Z)' },
    'mt+to': { start: 'D MMM HH:mm น.', end: 'D MMM HH:mm น. ([GMT]Z)' },
    'dt+to': { start: 'D MMM HH:mm น.', end: 'D MMM HH:mm น. ([GMT]Z)' },
    't+to': { start: 'HH:mm น.', end: 'HH:mm น. ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'th';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}.`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
